import { Directive, HostListener, ElementRef, OnInit, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
    selector: '[numeric]'
})
export class NumericDirective implements OnInit {

    @Input() decimals: number = 0;

    @Input() control: AbstractControl | any;

    private BACKSPACE = 'Backspace'; // KeyCode = 8
    private ENTER = 'Enter'; // KeyCode = 13
    private ESCAPE = 'Escape'; // KeyCode = 27
    private TAB = 'Tab'; // KeyCode = 9
    private DELETE = 'Delete'; // KeyCode = 46
    private POINT = '.'; // KeyCode = 110
    private NEGATIVE = '-';
    private NUM0 = '0'; // KeyCode =
    private NUM1 = '1'; // KeyCode =
    private NUM2 = '2'; // KeyCode =
    private NUM3 = '3'; // KeyCode =
    private NUM4 = '4'; // KeyCode =
    private NUM5 = '5'; // KeyCode =
    private NUM6 = '6'; // KeyCode =
    private NUM7 = '7'; // KeyCode =
    private NUM8 = '8'; // KeyCode =
    private NUM9 = '9'; // KeyCode =


    inputElement: HTMLElement;
    constructor(public el: ElementRef) {
        this.inputElement = el.nativeElement;
    }

    ngOnInit() {
        this.inputElement = this.el.nativeElement;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        if (this.isValidKey(e)) {
            return;
        }

        e.preventDefault();

    }

    @HostListener("blur")
    onBlur() {

        // Form
        if (this.control && this.control.valueChanges && typeof this.control.valueChanges === "object") {
            this.logicFormValue();
        } else { // NgModel
            this.logicValue();
        }

    }

    logicFormValue() {
        if (this.control !== undefined) {

            let value = this.control.value;
            if (value === null || value === '' || isNaN(value)) {
                value = '0';
            }
            this.control.setValue(Number(value).toFixed(this.decimals).toString(), { emitEvent: false });
        }
    }

    logicValue() {
        if (this.control !== undefined) {

            let value = this.control;
            if (value === null || value === '' || isNaN(value)) {
                value = '0';
            }
            this.control = Number(value).toFixed(this.decimals).toString();
        }
    }

    isValidKey(e: KeyboardEvent) {

        if (e.key === this.NEGATIVE) {
            const value = this.el.nativeElement.value;
            if (value.indexOf('-') === -1) {
                return true;
            }
        } else if (this.decimals > 0 && e.key === this.POINT) {

            const value = this.el.nativeElement.value;
            if (value.indexOf('.') === -1) {
                return true;
            }

        } else {

            if (
                e.key === this.BACKSPACE ||
                e.key === this.ENTER ||
                e.key === this.ESCAPE ||
                e.key === this.TAB ||
                e.key === this.DELETE ||
                e.key === this.NUM0 ||
                e.key === this.NUM1 ||
                e.key === this.NUM2 ||
                e.key === this.NUM3 ||
                e.key === this.NUM4 ||
                e.key === this.NUM5 ||
                e.key === this.NUM6 ||
                e.key === this.NUM7 ||
                e.key === this.NUM8 ||
                e.key === this.NUM9
            ) {
                return true;
            }
        }

        return false;
    }

}
